export const getDateString = (date = null) => {
  if (!date) {
    date = new Date();
  }
  let dateString = date
    .toISOString()
    .substring(0, date.toISOString().indexOf("T"));
  return dateString;
};
